import type { SignupRequest } from '../domain/account';
import { TERMS_VERSION } from '../domain/legal';

/** What the sign-up form holds: one field for an email or a phone. */
export type SignUpValues = {
  firstName: string;
  lastName: string;
  username: string;
  password: string;
  contact: string;
};

/**
 * The sign-up request from the form: "Email or phone number" is an email when
 * it has an `@`. Submitting the form, beside its notice, agrees to the terms.
 */
export function toSignupRequest(values: SignUpValues): SignupRequest {
  const contact = values.contact.trim();
  return {
    firstName: values.firstName.trim(),
    lastName: values.lastName.trim(),
    username: values.username.trim(),
    password: values.password,
    termsVersion: TERMS_VERSION,
    ...(contact && (contact.includes('@') ? { email: contact } : { phone: contact })),
  };
}
